const getPopover = () => {
    return `    
    //CUSTOMFILTERSELECTPOPOVER
    const CustomFilterSelectPopover = ({ customFiltersList, addCustomFilter, deleteCustomFilter, resetCustomFilters, oid, context, ...rest }) => {
    }
    export default CustomFilterSelectPopover;
    `;
}

export default getPopover;
